import { useVuexState } from '@scfe-common/micro-frontend-utils';

var useSystemEnums = function (selector) {
    // 注意：直接使用 VueCtxStore.state.enums.systemEnums 将会丢失响应式
    var systemEnums = useVuexState('enums.systemEnums');
    return typeof selector === 'function' ? selector(systemEnums) : systemEnums;
};

export { useSystemEnums as default };
